import { render, staticRenderFns } from "./comment-edit-form.vue?vue&type=template&id=d01d4420&"
import script from "./comment-edit-form.vue?vue&type=script&lang=js&"
export * from "./comment-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports